export const WORKSPACE_MAX_TITLE_LENGTH = 25
export const WORKSPACE_MIN_TITLE_LENGTH = 4
